// extracted by css-extract-rspack-plugin
export default {"root":"root-Q29KuP button-wpdoBc"};